import ArrowBack from '@mui/icons-material/ArrowBack';
import { Grid2 as Grid, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { Button } from '~/components/atoms/Button';
import { Link } from '~/components/atoms/Link';
import { HOME_PATH, SUPPORT_EMAIL } from '~/constants';

export const GenericError: FC<{ description?: string }> = ({ description }) => (
  <Grid container sx={{ justifyContent: 'center' }}>
    <Grid size={{ md: 6 }}>
      <Stack sx={{ p: 5, gap: 2, textAlign: 'center', alignItems: 'center' }}>
        <Typography variant="h3">Something&apos;s wrong.</Typography>
        <Stack sx={{ gap: 1 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {description || (
              <>
                We found an error while loading this page. Please try again or contact our support team at{' '}
                <Link to={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link> if the problem persists.
              </>
            )}
          </Typography>

          <Button variant="contained" to={HOME_PATH} startIcon={<ArrowBack />}>
            Back to home
          </Button>
        </Stack>
      </Stack>
    </Grid>
  </Grid>
);
